export default "__VITE_ASSET__c82b6323__"